module.exports = __webpack_public_path__ + "img/B1.16a450fa.jpg";